import axios from "axios";

const apiUrl = process.env.REACT_APP_API_URL;

export const checkPath = async (path = []) => {
    path = path.length ? path : window.location.pathname.split('/');
    if (path[1] === 'users'|| path[2] === 'users' || path[1] === 'invite' | path[1] === 'help-center' || path[1] === 'auth' || path[1] === 'termsandcondition' || path[1] === 'privacy' || path[1] === 'undefined'|| path[1] === 'firms') {
        return null;
    }
    const res = await axios.post(`${apiUrl}/check`, { path: path }, { withCredentials: true });
    return res.data;
}


export function normalizePath(input) {
  if (!input || typeof input !== "string") return "";

  const decoded = decodeURIComponent(input);

  return decoded
    .trim()
    .replace(/\s+/g, "-")               
    // .replace(/[^a-zA-Z0-9\-]/g, "")
    .toLowerCase();
}

export function normalizeString(input) {
  if (!input || typeof input !== "string") return "";

  return input
    .trim()
    .replace(/\s+/g, "-")               
    // .replace(/[^a-zA-Z0-9\-]/g, "")
    .toLowerCase();
}

export function denormalizeString(input) {
  if (!input || typeof input !== "string") return "";

  return input
    .trim()
    .replace(/-/g, " ")
    .replace(/\b\w/g, char => char.toUpperCase()); // capitalize first letter of each word
}